import http from "utils/http";
import { subscriptions } from "constants/endpoints";

const getSubscriptionByUserId = () => {
  const ENDPOINT = subscriptions.getSubscriptionByUserId();
  const { REACT_APP_API_BASE_URL: API_BASE_URL } = process.env;
  return http.get(`${API_BASE_URL}${ENDPOINT}`);
};

export default getSubscriptionByUserId;
